import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from "compid/custom-ui/CustomModal";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function DeleteBillerGroupModal
 * @param {STRING} onClick - Sets an event handler on click. 
 * @returns {React.Component}
 * @exported true
 * @description This modal shows when you delete a biller group.
 */
export default function DeleteBillerGroupModal(props) {
    const { close } = useBCMSModal();
    const data = props.data ?? {};
    const billerGroup = data.billerGroup ?? {};
    const billerGroupName = data.billerGroupName ?? "[billerName]";
  
    const onClick = () => {
      data.onDeleteButtonClick({ billerGroup: billerGroup });
      close("DeleteBillerGroupModal");
    };

    return (
        <CustomModal id="DeleteBillerGroupModal" className="delete-biller-group-modal large-icon-modal">
            <CustomModalContent className="flex-container flex-horizontal">
                <div className="set-width">
                    <SVGAsset id="AlertTriangleIcon" className="alert-triangle-icon left-icon" />
                </div>
                <div className="flex-width">
                    <h4 className="modal-title"><b>Delete { billerGroupName }?</b></h4>
                    <p className="sub-text">Are you sure you wish to delete this biller group? All billers within it will be moved to <b>Other billers</b>.</p>
                </div>
            </CustomModalContent>
            <CustomModalFooter className="form-button-container">
                <ModalCloseButton text="Cancel" id="DeleteBillerGroupModal" />
                <ModalPrimaryButton text="Delete" onClick={ onClick } />
            </CustomModalFooter>
        </CustomModal>
    )
}
